var borderT = {
  "borderTop": "0.0625rem solid #ecedee"
};

export { borderT };
